function normalizeTicketStatus(value) {
  return String(value || "").trim().toLowerCase();
}

export function didTicketJustClose(previousStatus, nextStatus) {
  return (
    normalizeTicketStatus(previousStatus) !== "closed" &&
    normalizeTicketStatus(nextStatus) === "closed"
  );
}
